import React from "react";
import {GridCell, gridConstants, GridContainer} from "../Grid";
import {LinkButton} from "../Link";
import {locations} from "../../Utilities/Location";
import {getFullName, isLoggedIn} from "../../Utilities/LocalStorage/storageUtilities";
import {createMenuItem, ProfileMenu} from "../ProfileMenu";
import {passwordApi} from "../../Containers/Password/passwordApi";
import type {HandleApiCall, User} from "../../types";

interface HeaderNavProps {
    handleApiCall: HandleApiCall;
    location?: { pathname: string };
    redirect?: (path: string) => void;
    showLoanLibraryCatalogLink?: boolean;
    showOwnCatalogLink?: boolean;
    user?: User;
}

export const HeaderNav: React.FC<HeaderNavProps> = ({
                              handleApiCall,
                              location = {pathname: ""},
                              redirect,
                              showLoanLibraryCatalogLink,
                              showOwnCatalogLink,
                              user,
                          }) => {

    const isDashboardPage = location.pathname === locations.DASHBOARD.path;
    const isLandingPage = location.pathname === locations.LANDING.path;
    const isUserLoggedIn = isLoggedIn();

    if (isLandingPage && !isUserLoggedIn) {
        return null;
    }

    const handleUpdatePassword = async (email: string) => {
        return handleApiCall(() => passwordApi.forgotPassword(email));
    };

    const profileLabel = isUserLoggedIn ? `Welcome, ${getFullName()}!` : null;
    const menuItems = isUserLoggedIn ? [
        createMenuItem(`Update Profile`, () => redirect!(locations.USER_PROFILE.getPath(user!.userId))),
        createMenuItem(`Update Password`, () => handleUpdatePassword(user!.email)),
        createMenuItem(`Sign out`, () => redirect!(locations.SIGN_OUT.path)),

    ] : null;

    return (
        <nav className="headerNav">
            <GridContainer hasMarginX>
                <GridCell small_columns={gridConstants.column.SIX}>
                    {
                        isUserLoggedIn &&
                        <ProfileMenu menuItems={menuItems!} profileLabel={profileLabel!}/>
                    }
                </GridCell>
                <GridCell small_columns={gridConstants.column.SIX}>
                    {
                        !isUserLoggedIn && !isLandingPage &&
                        <LinkButton {...locations.LANDING.link} />
                    }
                    {
                        !showLoanLibraryCatalogLink && !showOwnCatalogLink && !isDashboardPage && isUserLoggedIn &&
                        <LinkButton {...locations.DASHBOARD.link} />
                    }
                    {
                        showLoanLibraryCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.LOAN_LIBRARY_CATALOG.link} label="Loan Library" />
                    }
                    {
                        showOwnCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.OWN_CATALOG.link} label="Own Catalog" />
                    }
                </GridCell>
            </GridContainer>
        </nav>
    );
};
